/* eslint-disable */
export abstract class BaseModel {
  constructor (id: number) { }
}
